const moment = require('moment');
const { default: AggConstants } = require('../../constants/AggConstants');
const { default: TipoAtributo } = require('../../constants/TipoAtributo');
const { SPLIT_CHAR_SPECIAL } = require('../../constants/Split');
const { default: SystemConstants } = require('../../common/SystemConstants');
const Atributos = require('../../common/Atributos');
const FiltroConstants = require('../../constants/FiltroConstants').default;
module.exports = {
    cubo: 'cubo_fichas',
    title: SystemConstants.Strings.paginas.dadosExposicaoVitimaHumanaDadosPorGrupoDeAgentes,
    primeiraConsultaAutomatica: true,
    atributosSelecionados: [
        Atributos.F_AGENTE_GRUPO_DESCRICAO_ASSOC,
        Atributos.F_PACIENTE_FAIXA_ETARIA,
        // Atributos.QNT, // Sempre colocar o último atributo como métrica.
    ],
    nextPage: SystemConstants.SiteMapInterno.DADOS_EXPOSICAO_VITIMA_HUMANA_DADOS_POR_GRUPO_E_CLASSE_DOS_AGENTES,
    backPage: SystemConstants.SiteMapInterno.DADOS_EXPOSICAO_VITIMA_HUMANA_ENCERRAMENTO,
    charts: [
        {
            title: 'GRUPO DE AGENTES',
            description: 'Grupo (Isolado/Associação).',
            type: 'Pivottable',
            headers: ['Grupo (Isolado/Associação)', 'Quantidade'],
            selectDimensions: [Atributos.F_AGENTE_GRUPO_DESCRICAO_ASSOC, Atributos.QNT],
            rows: ['Grupo (Isolado/Associação)'],
            rowOrder: 'value_z_to_a',
            aggregatorName: 'Sum as Fraction of Total',
            vals: ['Quantidade'],
            aggregatorList: [
                {
                    vals: ['Quantidade'],
                    aggTitle: 'Quantidade',
                    aggregatorName: 'Integer Sum',
                },
                {
                    vals: ['Quantidade'],
                    aggTitle: '%',
                    aggregatorName: 'Sum as Fraction of Total',
                },
            ],
            cols: [],
            filters: [],
            transformations: [
                {
                    attributes: [Atributos.F_AGENTE_GRUPO_DESCRICAO_ASSOC],
                    transformation: (value) => {
                        if (value === 'Não preenchido')
                            return 'Ignorado';
                        return value;
                    },
                },
            ],
        },
        {
            title: 'GRUPO DE AGENTES',
            description: 'Grupo de Agentes.',
            type: 'ApexBarChart',
            w: 1,
            selectDimensions: [Atributos.F_AGENTE_GRUPO_DESCRICAO_ASSOC, Atributos.QNT],
            filters: [],
            transformations: [
                {
                    attributes: [Atributos.F_AGENTE_GRUPO_DESCRICAO_ASSOC],
                    transformation: (value) => {
                        if (value === 'Não preenchido')
                            return 'Ignorado';
                        return value;
                    },
                },
            ],
            uiConfig: {
                enableAnimation: true,
                orderDirection: 'desc',
                orderType: 'count', // 'name' | 'count'
            },
        },
        {
            title: 'GRUPO DE AGENTES POR FAIXA ETÁRIA',
            description: 'Grupo de Agentes por Faixa Etária.',
            type: 'Pivottable',
            w: 6,
            headers: ['Faixa Etária', 'Grupo (Isolado/Associação)', 'Quantidade'],
            selectDimensions: [Atributos.F_PACIENTE_FAIXA_ETARIA, Atributos.F_AGENTE_GRUPO_DESCRICAO_ASSOC, Atributos.QNT],
            rows: ['Grupo (Isolado/Associação)'],
            rowOrder: 'value_z_to_a',
            // aggregatorName: 'Integer Sum',
            aggregatorList: [
                {
                    vals: ['Quantidade'],
                    aggTitle: 'Quantidade',
                    aggregatorName: 'Integer Sum',
                },
                {
                    vals: ['Quantidade'],
                    aggTitle: '%',
                    aggregatorName: 'Sum as Fraction of Total',
                },
            ],
            enablePercentage: true,
            vals: ['Quantidade'],
            cols: ['Faixa Etária'],
            filters: [],
            transformations: [
                {
                    attributes: [Atributos.F_PACIENTE_FAIXA_ETARIA],
                    transformation: (value) => {
                        switch (value) {
                            case 'Não preenchido':
                                return 'Ignorado';
                            case '<1':
                                return ' <1';
                            default:
                                return value;
                        }
                    },
                },
                {
                    attributes: [Atributos.F_AGENTE_GRUPO_DESCRICAO_ASSOC],
                    transformation: (value) => {
                        if (value === 'Não preenchido')
                            return 'Ignorado';
                        return value;
                    },
                },
            ],
        },
    ],
    metaAtributos: [
        {
            atributo: Atributos.F_CABECALHO_NOME_CENTRO,
            grupo: 'Nome do centro',
            rotulo: 'Nome do centro',
            tipo: 'TEXTO',
        },
        {
            atributo: Atributos.F_ATENDIMENTO_DATA_ANO,
            grupo: 'Ano de atendimento',
            rotulo: 'Ano de atendimento',
            tipo: 'TEXTO',
        },
        {
            atributo: Atributos.F_CABECALHO_TIPO_FICHA,
            grupo: 'Tipo de Ficha',
            rotulo: 'Tipo de Ficha',
            tipo: 'TEXTO',
        },
        {
            atributo: Atributos.F_SOLICITANTE_ESTADO_SIGLA,
            grupo: 'UF Solicitante',
            rotulo: 'UF Solicitante',
            tipo: 'TEXTO',
        },
        {
            atributo: Atributos.GRUPO,
            grupo: 'Grupo de agentes',
            rotulo: 'Grupo de agentes',
            tipo: 'TEXTO',
        },
        {
            atributo: Atributos.F_PACIENTE_SEXO,
            grupo: 'Paciente: Sexo',
            rotulo: 'Paciente: Sexo',
            tipo: 'TEXTO',
        },
        {
            atributo: Atributos.F_PACIENTE_FAIXA_ETARIA,
            grupo: 'Paciente: Faixa etária',
            rotulo: 'Paciente: Faixa etária',
            tipo: 'TEXTO',
        },
        {
            atributo: Atributos.F_ENCERRAMENTO_EVOLUCAO_CLINICA_DESCRICAO,
            grupo: 'Exposição: Circunstância',
            rotulo: 'Exposição: Circunstância',
            tipo: 'TEXTO',
        },
        {
            atributo: Atributos.F_ENCERRAMENTO_CLASS_GRAVI_DESCRICAO,
            grupo: 'Classificação de Gravidade Final',
            rotulo: 'Classificação de Gravidade Final',
            tipo: 'TEXTO',
        },
        {
            atributo: Atributos.CIRCUNSTANCIA_DESCRICAO,
            grupo: 'Desfecho',
            rotulo: 'Desfecho',
            tipo: 'TEXTO',
        },
    ],
    preFiltrosServer: [
        {
            atributo: Atributos.F_ATENDIMENTO_DATA_ANO,
            tipoComponente: 'IN_SELECT',
            valor: ['2014', '2015', '2016', '2017', '2018', '2019', '2020', '2021', '2022', '2023', '2024', '2025', '2026'].join(FiltroConstants.SPLIT_VALUES),
        },
    ],
    filtros: [
        {
            key: 0,
            disabled: true,
            hidden: true,
            atributo: Atributos.F_CABECALHO_TIPO_FICHA,
            rotulo: 'Tipo de ficha',
            tipoComponente: 'IN_SELECT',
            valor: '',
        },
        {
            key: 1,
            size: 2,
            disabled: true,
            atributo: Atributos.F_ATENDIMENTO_DATA_ANO,
            rotulo: 'Ano do atendimento',
            tipoComponente: 'IN_SELECT',
            valor: '',
        },
        {
            key: 2,
            size: 2,
            disabled: false,
            atributo: Atributos.GRUPO,
            rotulo: 'Grupo de agentes',
            tipoComponente: 'IN_SELECT',
            valor: '',
        },
        {
            key: 3,
            size: 2,
            disabled: false,
            atributo: Atributos.F_PACIENTE_SEXO,
            rotulo: 'Sexo',
            tipoComponente: 'IN_SELECT',
            valor: '',
        },
        {
            key: 4,
            size: 2,
            disabled: false,
            atributo: Atributos.F_PACIENTE_FAIXA_ETARIA,
            rotulo: 'Faixa etária',
            tipoComponente: 'IN_SELECT',
            valor: '',
        },
        {
            key: 5,
            size: 2,
            disabled: true,
            atributo: Atributos.F_SOLICITANTE_ESTADO_SIGLA,
            rotulo: 'UF Solicitante',
            tipoComponente: 'IN_SELECT',
            valor: '',
        },
        {
            key: 6,
            size: 2,
            disabled: false,
            atributo: Atributos.F_CABECALHO_NOME_CENTRO,
            rotulo: 'Nome do centro',
            tipoComponente: 'IN_SELECT',
            valor: '',
        },
        {
            key: 7,
            size: 2,
            disabled: false,
            atributo: Atributos.CIRCUNSTANCIA_DESCRICAO,
            rotulo: 'Circunstância',
            tipoComponente: 'IN_SELECT',
            valor: '',
        },
        {
            key: 8,
            size: 2,
            disabled: false,
            atributo: Atributos.F_ENCERRAMENTO_EVOLUCAO_CLINICA_DESCRICAO,
            rotulo: 'Desfecho',
            tipoComponente: 'IN_SELECT',
            valor: '',
        },
    ],
};
